import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    marginBottom: theme.spacing(4),
    color: theme.palette.neutral.main,
  },
  content: {
    height: '100%',
    padding: theme.spacing(7, 8),
  },
  contentRight: {
    backgroundColor: theme.palette.neutral.lightest,
  },
  formTitle: {
    marginBottom: theme.spacing(4),
  },
  contentTitle: {
    marginBottom: theme.spacing(2),
  },
  paperContent: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  info: {
    marginBottom: theme.spacing(2),
    color: theme.palette.neutral.main,
  },
  infoTeamViewer: {
    maxWidth: 432,
    marginBottom: theme.spacing(4),
    color: theme.palette.neutral.main,
    lineHeight: 1.43,
  },
  infoRequirements: {
    marginBottom: theme.spacing(8),
    color: theme.palette.neutral.main,
  },
  textArea: {
    marginBottom: theme.spacing(4),
  },
  helpBox: {
    width: '100%',
    justifyContent: 'left',
    display: 'flex',
  },
  manualButton: {
    marginRight: '10px !important',
  },
  contactEmail: {
    marginBottom: theme.spacing(8),
  },
  remote: {
    margin: theme.spacing(2, 0, 4.5),
    display: 'flex',
    alignItems: 'center',
  },
  remoteTooltip: {
    maxWidth: 272,
  },
  remoteTooltipLink: {
    color: theme.palette.neutral.white,
    '&::after': {
      backgroundColor: theme.palette.neutral.white,
      width: '100%',
    },
  },
  remoteLink: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'help',

    '&:hover': {
      '&::after': {
        width: `calc(100% - ${theme.spacing(4)})`,
      },

      '& $remoteIcon': {
        color: theme.palette.primary.dark,
      },
    },
  },
  remoteIcon: {
    marginLeft: theme.spacing(1),
  },
  downloadTeams: {
    width: '-webkit-fill-available',
    maxWidth: 300,
    margin: 5,
  },
  fields: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2),
    rowGap: theme.spacing(3),
    columnGap: theme.spacing(2),
    '& .MuiInputBase-colorSuccess .MuiInput-input': {
      boxShadow: `0 0 0 100px ${theme.palette.success.light} inset`,
      backgroundColor: theme.palette.success.light,
      borderColor: theme.palette.green.light,
      borderBottomColor: theme.palette.success.dark,
    },
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%', // Ajusta el ancho según tus necesidades
    backgroundColor: theme.palette.neutral.white,
    boxShadow: 24,
    p: 4,
    overflowY: 'auto',
  },
  gridContainer: {
    display: 'flex',
    justifyContent: 'center', // Centra el grid horizontalmente
    padding: theme.spacing(2), // Espaciado alrededor del grid
    marginTop: theme.spacing(4), // Margen en la parte superior del grid
    marginBottom: theme.spacing(4), // Margen en la parte inferior del grid
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Centra el contenido de cada item del grid
    marginBottom: theme.spacing(2), // Margen entre filas
  },
}))

export default useStyles
